import { render, staticRenderFns } from "./u-checkbox.vue?vue&type=template&id=74685273&scoped=true&"
import script from "./u-checkbox.vue?vue&type=script&lang=js&"
export * from "./u-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./u-checkbox.vue?vue&type=style&index=0&id=74685273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74685273",
  null
  
)

export default component.exports